import { render, staticRenderFns } from "./picSelector.vue?vue&type=template&id=bf2b9866&scoped=true"
import script from "./picSelector.vue?vue&type=script&lang=js"
export * from "./picSelector.vue?vue&type=script&lang=js"
import style0 from "./picSelector.vue?vue&type=style&index=0&id=bf2b9866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2b9866",
  null
  
)

export default component.exports